import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import { updateFloatPanel } from "../../reducers/userConfigSlice";

export const FloatPanel = ({ template, className = "" }) => {
  const visible = useSelector((state) => state.aplicationConfig.userConfig.floatPanel.visible);
  const dispatch = useDispatch();
  const panelRef = useRef(null);
  useEffect(() => {
    if (!visible) return;
    const previous = document.activeElement;
    const panel = panelRef.current;
    panel.querySelector("button")?.focus();
    const handleKeys = event => {
      if (event.key === "Escape") {
        if (panel.querySelector('[aria-busy="true"]')) return;
        event.preventDefault();
        dispatch(updateFloatPanel({visible:false,queryId:null,isEmpty:true}));
      }
      if (event.key !== "Tab") return;
      const fields = Array.from(panel.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),summary,[tabindex="0"]')).filter(field=>!field.matches(":disabled") && field.getClientRects().length);
      const first = fields[0], last = fields[fields.length-1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    };
    panel.addEventListener("keydown", handleKeys);
    return () => { panel.removeEventListener("keydown", handleKeys); previous?.focus?.(); };
  }, [visible, dispatch]);
  return visible && <>
    <div className="floatPanelBackground"></div>
    <div ref={panelRef} className={`floatPanel slide-left ${className}`} role="dialog" aria-modal="true" aria-labelledby="admin-editor-title">{template}</div>
    <div className="shadow"></div>
  </>;
};
